var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11319 6.92507V3.17264C9.11319 2.88339 8.95516 2.62169 8.71811 2.48985L5.37179 0.598878C5.13475 0.467041 4.81868 0.467041 4.58164 0.598878L1.261 2.46427C1.02396 2.5961 0.865924 2.85781 0.865924 3.12148V6.87588C0.865924 7.13758 1.02396 7.40126 1.261 7.53309L4.60732 9.42406C4.84436 9.5559 5.16043 9.5559 5.39747 9.42406L8.71811 7.58622C8.95516 7.45045 9.11319 7.18678 9.11319 6.92507ZM3.76382 9.57558L1.28668 8.18441C1.20767 8.15883 1.12865 8.18441 1.07532 8.23753L0.0204554 9.91796C-0.0328802 10.0222 0.0204555 10.1541 0.152807 10.1541L1.57509 10.2328C1.62843 10.2328 1.65411 10.2584 1.67979 10.2859L2.54896 11.441C2.62797 11.5197 2.76033 11.5197 2.81169 11.441L3.81321 9.78612C3.86852 9.70741 3.84284 9.62871 3.76382 9.57558ZM9.98039 9.89041L8.92948 8.20999C8.87614 8.13128 8.79713 8.1057 8.71811 8.15686L6.24097 9.55C6.16195 9.60313 6.13627 9.68183 6.18763 9.76054L7.18916 11.4134C7.24249 11.4921 7.37287 11.4921 7.45188 11.4134L8.32106 10.2584C8.34674 10.2328 8.37439 10.2052 8.42575 10.2052L9.84804 10.1265C9.98039 10.1265 10.0317 9.9947 9.98039 9.89041Z",
    fill: "#FFF277"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24957 3.28484L6.80827 4.10762C6.96076 4.18811 7.05618 4.34637 7.0562 4.5188L7.05629 5.63858C7.0563 5.80431 6.9681 5.95753 6.82477 6.04075L5.26658 6.94544C5.11796 7.03173 4.93387 7.02901 4.78786 6.93838L3.34607 6.04341C3.20942 5.95859 3.12631 5.80917 3.12631 5.64834V4.50934C3.12631 4.34157 3.21668 4.18682 3.36278 4.10437L4.80397 3.2911C4.94176 3.21334 5.10964 3.21098 5.24957 3.28484Z",
    fill: "black",
    stroke: "url(#paint0_linear_4443_6716)",
    strokeWidth: 0.07
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4443_6716",
    x1: 5.02457,
    y1: 3.12646,
    x2: 5.08706,
    y2: 7.12653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6CB41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade);
export default __webpack_public_path__ + "static/media/grade.071d94b9cf243a40faf732e30457d46c.svg";
export { ForwardRef as ReactComponent };